var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStickers = function SvgStickers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M13.157 13.625 16 11.906l2.844 1.719-.75-3.25 2.5-2.156-3.281-.281L16 4.874l-1.312 3.063-3.281.28 2.5 2.157zm.593 8.125h7q-.217.813-.75 1.313-.53.5-1.375.625L5 25.344a2.35 2.35 0 0 1-1.859-.485 2.4 2.4 0 0 1-.953-1.672L.532 9.532a2.43 2.43 0 0 1 .5-1.844 2.37 2.37 0 0 1 1.656-.937l1.437-.187v2.5L3 9.219l1.688 13.656zm-4.625-2.5a2.4 2.4 0 0 1-1.765-.734 2.4 2.4 0 0 1-.735-1.766V3q0-1.03.735-1.766A2.4 2.4 0 0 1 9.125.5h13.75q1.032 0 1.766.734.734.735.734 1.766v13.75q0 1.032-.734 1.766t-1.766.734zm0-2.5h13.75V3H9.125z"
  })));
};
export default SvgStickers;